// Helpers de resolución de idiomas del tenant.
// La API devuelve todos los idiomas del tenant con un flag `active`; la interfaz debe
// mostrarse siempre en un idioma activo. Si el idioma seleccionado (navegador o persistido)
// no está entre los activos, se resuelve al primer idioma activo.

// Normaliza la respuesta de la API de idiomas (array o { languages: [...] }) a un array.
export const normalizeLanguageList = (languageList) =>
  Array.isArray(languageList)
    ? languageList
    : Array.isArray(languageList?.languages)
      ? languageList.languages
      : [];

// Devuelve los idiomas activos del tenant.
export const getActiveLanguages = (languageList) =>
  normalizeLanguageList(languageList).filter(
    (language) => language && language.active === true,
  );

// Resuelve el idioma por defecto válido para el tenant:
// - si `currentLanguage` ya está entre los idiomas activos, devuelve null (no hay que cambiar);
// - si no, devuelve el código del primer idioma activo;
// - si no hay idiomas activos, devuelve null.
export const resolveDefaultLanguage = (languageList, currentLanguage) => {
  const activeLanguages = getActiveLanguages(languageList);
  if (activeLanguages.length === 0) return null;

  const current = String(currentLanguage || "").toLowerCase();
  const isActive = activeLanguages.some(
    (language) => String(language.code).toLowerCase() === current,
  );
  if (isActive) return null;

  return String(activeLanguages[0].code).toLowerCase();
};
